import { notifyPropertyChange as _notifyPropertyChange } from '@ember/object';
export const notifyPropertyChange = _notifyPropertyChange;